/**
 * Check if URL is from trusted video sources
 * @param {string} url - Video URL to check
 * @returns {boolean} - True if URL is from trusted source
 */
export function isTrustedVideoUrl(url) {
  if (!url || typeof url !== 'string') return false;

  // List of trusted video embed sources
  const trustedSources = [
    // YouTube formats
    /^https:\/\/(www\.)?youtube\.com\/embed\//,
    /^https:\/\/(www\.)?youtube\.com\/watch\?v=/,
    /^https:\/\/(www\.)?youtube\.com\/shorts\//,
    /^https:\/\/(www\.)?youtube\.com\/v\//,
    /^https:\/\/m\.youtube\.com\/watch\?v=/,
    /^https:\/\/youtu\.be\//,
    // Vimeo formats
    /^https:\/\/(www\.)?vimeo\.com\//,
    /^https:\/\/player\.vimeo\.com\//,
    // TikTok formats
    /^https:\/\/(www\.)?tiktok\.com\/embed\//,
    /^https:\/\/(www\.)?tiktok\.com\/@[\w.-]+\/video\/\d+/,
    /^https:\/\/vm\.tiktok\.com\//
  ];

  return trustedSources.some(pattern => pattern.test(url));
}
